export default __webpack_public_path__ + "static/media/rabbit26.d642d269.gif";